// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.title {
  font-size: 10rem;
}



.caja{ 
  width: 100%;
  height: 691px;
  margin: 0 auto;
  padding: 0 0 0 3%;
  /* background-color: brown; */
  display: flex;
  justify-content:center;
  
  column-gap: 100px;
  flex-wrap: nowrap;
  overflow: hidden;

}

.texto{
  /* background-color: aqua; */
  height: 455px;
  width: 574px;
  font-size: 77px;
  line-height: 133px;
  padding: 135px 0 0 0;
  font-family: 'Bebas Neue', cursive;
}

.slider{  
  /* background-color: rgb(255, 255, 255); */
  height: 771px;
  width:971px;
 
 padding: 67px 0;
  overflow: hidden;
}


@media screen and (max-width: 1699px) {
.caja{ 
  width: 1200px;
  height: 479px;
  margin: 30px auto 0px auto;
  padding: 1% 0 0 3%;
  /* background-color: brown; */
  display: flex;
   column-gap: 1px;
  justify-content:flex-end;
  

}

.texto{
  /* background-color: aqua; */
  height: 455px;
  width: 399px;  
  font-size:51px;
  line-height: 97px;
 
  padding: 79px 0 0 0;
  font-family: 'Bebas Neue', cursive;
}

.slider{  
  /* background-color: rgb(255, 255, 255); */
  height: 561px;
  width:727px;
 
 padding: 71px 0;
  overflow: hidden;
}
}


@media screen and (max-width: 1223px) {
  .caja{ 
    width: 1047px;}
  .texto{
 height: 455px;
    width: 279px;  
    font-size:37px;
    line-height: 77px;  
  }
 
}

@media screen and (max-width: 1067px) {
  .caja{ 
    width: 100%;}
  .texto{
    height: 455px;
       width: 209px;  
       font-size:27px;
       line-height: 57px;  
     }
}



@media screen and (max-width: 955px) {
  .slider{  
   height: 561px;
    width:727px;
  }
  
  .caja{ 
    width: 629px;}

    .texto{
    height: 255px;
       width: 215px;  
       font-size:17px;
       line-height: 37px;  
     }
}

@media screen and (max-width: 655px) {
  .caja{ 
      flex-direction: column;
    width: 417px;
    height: 373px;
    justify-content: center;
    margin: 0 auto;
    
  }

  .slider {
    height: 561px;
    width: 476px;
}
.texto{ display: none;
  /* height: 455px;
     width: 279px;  
     font-size:37px;
     line-height: 77px;  
     margin-left: 13px; */
   }


}

@media screen and (max-width: 397px) {
  .caja{ 
     width: 389px;
     height: 271px;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/intro/intro.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;AAClB;;;;AAIA;EACE,WAAW;EACX,aAAa;EACb,cAAc;EACd,iBAAiB;EACjB,6BAA6B;EAC7B,aAAa;EACb,sBAAsB;;EAEtB,iBAAiB;EACjB,iBAAiB;EACjB,gBAAgB;;AAElB;;AAEA;EACE,4BAA4B;EAC5B,aAAa;EACb,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,oBAAoB;EACpB,kCAAkC;AACpC;;AAEA;EACE,0CAA0C;EAC1C,aAAa;EACb,WAAW;;CAEZ,eAAe;EACd,gBAAgB;AAClB;;;AAGA;AACA;EACE,aAAa;EACb,aAAa;EACb,0BAA0B;EAC1B,kBAAkB;EAClB,6BAA6B;EAC7B,aAAa;GACZ,eAAe;EAChB,wBAAwB;;;AAG1B;;AAEA;EACE,4BAA4B;EAC5B,aAAa;EACb,YAAY;EACZ,cAAc;EACd,iBAAiB;;EAEjB,mBAAmB;EACnB,kCAAkC;AACpC;;AAEA;EACE,0CAA0C;EAC1C,aAAa;EACb,WAAW;;CAEZ,eAAe;EACd,gBAAgB;AAClB;AACA;;;AAGA;EACE;IACE,aAAa,CAAC;EAChB;CACD,aAAa;IACV,YAAY;IACZ,cAAc;IACd,iBAAiB;EACnB;;AAEF;;AAEA;EACE;IACE,WAAW,CAAC;EACd;IACE,aAAa;OACV,YAAY;OACZ,cAAc;OACd,iBAAiB;KACnB;AACL;;;;AAIA;EACE;GACC,aAAa;IACZ,WAAW;EACb;;EAEA;IACE,YAAY,CAAC;;IAEb;IACA,aAAa;OACV,YAAY;OACZ,cAAc;OACd,iBAAiB;KACnB;AACL;;AAEA;EACE;MACI,sBAAsB;IACxB,YAAY;IACZ,aAAa;IACb,uBAAuB;IACvB,cAAc;;EAEhB;;EAEA;IACE,aAAa;IACb,YAAY;AAChB;AACA,QAAQ,aAAa;EACnB;;;;yBAIuB;GACtB;;;AAGH;;AAEA;EACE;KACG,YAAY;KACZ,aAAa;EAChB;AACF","sourcesContent":[".title {\n  font-size: 10rem;\n}\n\n\n\n.caja{ \n  width: 100%;\n  height: 691px;\n  margin: 0 auto;\n  padding: 0 0 0 3%;\n  /* background-color: brown; */\n  display: flex;\n  justify-content:center;\n  \n  column-gap: 100px;\n  flex-wrap: nowrap;\n  overflow: hidden;\n\n}\n\n.texto{\n  /* background-color: aqua; */\n  height: 455px;\n  width: 574px;\n  font-size: 77px;\n  line-height: 133px;\n  padding: 135px 0 0 0;\n  font-family: 'Bebas Neue', cursive;\n}\n\n.slider{  \n  /* background-color: rgb(255, 255, 255); */\n  height: 771px;\n  width:971px;\n \n padding: 67px 0;\n  overflow: hidden;\n}\n\n\n@media screen and (max-width: 1699px) {\n.caja{ \n  width: 1200px;\n  height: 479px;\n  margin: 30px auto 0px auto;\n  padding: 1% 0 0 3%;\n  /* background-color: brown; */\n  display: flex;\n   column-gap: 1px;\n  justify-content:flex-end;\n  \n\n}\n\n.texto{\n  /* background-color: aqua; */\n  height: 455px;\n  width: 399px;  \n  font-size:51px;\n  line-height: 97px;\n \n  padding: 79px 0 0 0;\n  font-family: 'Bebas Neue', cursive;\n}\n\n.slider{  \n  /* background-color: rgb(255, 255, 255); */\n  height: 561px;\n  width:727px;\n \n padding: 71px 0;\n  overflow: hidden;\n}\n}\n\n\n@media screen and (max-width: 1223px) {\n  .caja{ \n    width: 1047px;}\n  .texto{\n height: 455px;\n    width: 279px;  \n    font-size:37px;\n    line-height: 77px;  \n  }\n \n}\n\n@media screen and (max-width: 1067px) {\n  .caja{ \n    width: 100%;}\n  .texto{\n    height: 455px;\n       width: 209px;  \n       font-size:27px;\n       line-height: 57px;  \n     }\n}\n\n\n\n@media screen and (max-width: 955px) {\n  .slider{  \n   height: 561px;\n    width:727px;\n  }\n  \n  .caja{ \n    width: 629px;}\n\n    .texto{\n    height: 255px;\n       width: 215px;  \n       font-size:17px;\n       line-height: 37px;  \n     }\n}\n\n@media screen and (max-width: 655px) {\n  .caja{ \n      flex-direction: column;\n    width: 417px;\n    height: 373px;\n    justify-content: center;\n    margin: 0 auto;\n    \n  }\n\n  .slider {\n    height: 561px;\n    width: 476px;\n}\n.texto{ display: none;\n  /* height: 455px;\n     width: 279px;  \n     font-size:37px;\n     line-height: 77px;  \n     margin-left: 13px; */\n   }\n\n\n}\n\n@media screen and (max-width: 397px) {\n  .caja{ \n     width: 389px;\n     height: 271px;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
